export const getRankColor = (rank: string): string => {
  switch (rank) {
    case 'Attention':
      return '#FF3A3A';
    case 'Improve':
      return '#FFAB01';
    case 'Maintain':
      return '#00CA9F';
    default:
      return '#ffff'; // Default color (black) if rank doesn't match
  }
};
